var UserRoles = {
  Advertiser: "advertiser",
  Creator: "creator",
  Admin: "admin",
  Sponsor: "sponsor",
};

export default UserRoles;
